<div class="{{ this.isDesktop ? 'view-desktop' : 'view-mobile' }}">
    <div class="question">
        <h3 class="question-title">{{ question.title }}</h3>
        <div class="question-description">{{ question.text }}</div>
        <div class="question-answer">
            <mat-slider class="question-answer-borg" min="0" max="10" step="1" showTickMarks discrete>
              <input matSliderThumb [(ngModel)]="value" (input)="onSliderChange($event, question.id!)">
            </mat-slider>
            <div class="slider-ticks-label">
                <ul>
                    <li>{{ 'Borg1' | translate }}</li>
                    <li>{{ 'Borg2' | translate }}</li>
                    <li>{{ 'Borg3' | translate }}</li>
                    <li>{{ 'Borg4' | translate }}</li>
                    <li>{{ 'Borg5' | translate }}</li>
                    <li>{{ 'Borg6' | translate }}</li>
                    <li>{{ 'Borg7' | translate }}</li>
                    <li>{{ 'Borg8' | translate }}</li>
                    <li>{{ 'Borg9' | translate }}</li>
                    <li>{{ 'Borg10' | translate }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
